import React from 'react'
import { Link } from 'react-router-dom'
import Layout from '../components/layout/Layout'
import GlassContainer from '../components/ui/GlassContainer'
import Button from '../components/ui/Button'

const NotFound = () => {
  return (
    <Layout>
      <section className="py-20 lg:py-32">
        <div className="container mx-auto px-4">
          <div className="max-w-2xl mx-auto text-center">
            <GlassContainer className="p-12">
              <h1 className="heading-xl mb-6">404 - Page Not Found</h1>
              <p className="body-lg mb-8">
                The page you're looking for is missing, just like Congress during recess.
              </p>
              <Link to="/">
                <Button variant="primary">
                  Return Home
                </Button>
              </Link>
            </GlassContainer>
          </div>
        </div>
      </section>
    </Layout>
  )
}

export default NotFound
